import { connectStore as _connectStore } from './store';
import Translate, { translate }  from './i18n/Translate';
import { i18n as i18nReducer }  from './i18n/reducer';
import { getTranslations, setActiveLanguage }  from './i18n/actions';
import { createHttpAction as _createHttpAction }  from './http/http';
import _Next  from './http/Next';
import _Uploader from './Uploader';
import _MultiUploader from './MultiUploader';
import _InfoTooltip from './InfoTooltip';
import _ServerError from './ServerError';
import _SecuritizePage from './SecuritizePage';
import _AnonymousDocsDisplay from './AnonymousDocsDisplay';
import _ContactUs from './ContactUs';
import _ErrorAlert from './ErrorAlert';
import _LanguageSelect from './LanguageSelect';


export const Uploader = _Uploader;
export const MultiUploader = _MultiUploader;
export const connectStore =  _connectStore;
export const InfoTooltip = _InfoTooltip;
export const ServerError = _ServerError;
export const SecuritizePage = _SecuritizePage;
export const AnonymousDocsDisplay = _AnonymousDocsDisplay;
export const ContactUs = _ContactUs;
export const createHttpAction = _createHttpAction;
export const Next = _Next;
export const ErrorAlert = _ErrorAlert;
export const LanguageSelect = _LanguageSelect;

export const i18n = {
  Translate,
  translate,
  actions: {
    getTranslations,
    setActiveLanguage,
  },
  reducer: i18nReducer,
};

/*
import { Next } from '@securitize/ui-components';
import { createHttpAction } from '@securitize/ui-components';
 */

